<template>
    <div>
        <div ref="test" class="round-btn" @click="expandMap()"><i class="fas fa-expand" /></div>
        <general-dialog 
            :is-dialog.sync="isDialog" 
            :title="dialogTitle" 
            :is-button="false"
            :dialog-width="'80%'"
        >
            <template #content>
                <recording-map-2 ref="recording_map" :gps-location="gpsLocation" :map-id="'expand_map'" :map-height="'500'" />
            </template>
        </general-dialog>
    </div>
</template>

<script>
import GeneralDialog from "@/components/Dialog/GeneralDialog";
import RecordingMap2 from "@/components/Dashboard/RecordingMap2";

export default {
    components: {
        "general-dialog": GeneralDialog,
        "recording-map-2": RecordingMap2,
    },
    props: {
        gpsLocation: {
            type: Object
        }
    },
    data() {
        return {
            dialogTitle: "Map Location",
            isDialog: false
        };
    },
    methods: {
        expandMap() {
            this.isDialog = true;
            this.$nextTick(() => {
                this.$refs["recording_map"].drawMap();
            });
        }
    }
};
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/ExpandMap.vue